import React, { useContext, useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import Chat from './Chat'
import { MainContext } from 'context/mainContext';
import { generateUUID } from 'services/EVAResponseService';

function EVATemplates({ handleNewUpdate, selectedDashboardTemplate, handlePintoDashboardUpdate, handleLoadEVAResponseToTemplate }) {
    const [selectedUUID, setSelectedUUID] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [isOpenTab, setIsOpenTab] = useState(false)
    const [alert, setAlert] = useState(false);
    const [decodedToken, setDecodedToken] = useState(null);
    const [isEVAPage, setIsEVAPage] = useState(false)

    const {
        bgColor,
        textColor,
        selectedClientID,
        userDetails,
        firmDetails,
        selectedClient,
    } = useContext(MainContext);

    const theme = {
        PrimaryColor: bgColor,
        TextColor: textColor
    }
    useEffect(() => {
        const generateUuidAndDecode = async () => {
            const uuid = await generateUUID();
            setSelectedUUID(uuid);

            const userData = {
                "business": {
                    "id": firmDetails.id,
                    "uid": firmDetails.AccountingFirmID,
                    "name": firmDetails.Name,
                    "code": firmDetails.Code,
                    "theme": {
                        "TextColor": "#fff",
                        "PrimaryColor": "#000b8a"
                    }
                },
                "client": {
                    "id": selectedClient.id,
                    "uid": selectedClientID,
                    "name": selectedClient.Name
                },
                "user": {
                    "id": userDetails.User.id,
                    "uid": userDetails.User.UserID,
                    "fullName": `${userDetails.User.FirstName} ${userDetails.User.LastName}`
                },
                "iat": 1748234968,
                "exp": 1748321368
            }

            setDecodedToken(userData)
        };
        
        generateUuidAndDecode();
    }, []);
    const handleSelectUUID = (uuid) => {
        setSelectedUUID(uuid);
    }
    const handleIsLoading = (val) => {
        setIsLoading(!isLoading)
    }
    const handleOpenTab = () => {
        setIsOpenTab(!isOpenTab)
    }
    const handleSetAlert = (val) => {
        setAlert(val)
    }
    return (
        <div className="home" style={{ height: '100%'}}>
            <div className="evaContainer">
            {alert}
            {/* {isLoading && <Loading />} */}
            {decodedToken && decodedToken.business && decodedToken.client && decodedToken.user &&
                <>
                    {isOpenTab && (
                        <Sidebar
                            onSelectUUID={handleSelectUUID}
                            selectedUUID={selectedUUID}
                            userData={decodedToken}
                            theme={theme}
                            isOpenTab={isOpenTab}
                            onIsLoading={handleIsLoading}
                            onSetAlert={handleSetAlert}
                            handleOpenTab={handleOpenTab}
                        />
                    )}
                    <Chat
                        handleOpenTab={handleOpenTab}
                        onSelectUUID={handleSelectUUID}
                        selectedUUID={selectedUUID}
                        userData={decodedToken}
                        theme={theme}
                        onIsLoading={handleIsLoading}
                        handleNewUpdate={handleNewUpdate}
                        isEVAPage={isEVAPage}
                        selectedDashboardTemplate={selectedDashboardTemplate}
                        handlePintoDashboardUpdate={handlePintoDashboardUpdate}
                        handleLoadEVAResponseToTemplate={handleLoadEVAResponseToTemplate}
                    />
                </>
            }
            </div>
        </div>
    )
}

export default EVATemplates